module.exports = __webpack_public_path__ + "static/media/barcode.77cd4102.png";